import { RouterOutlet } from '@angular/router';
import { Component, OnInit, PLATFORM_ID, Signal, computed, inject } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { NovaIconRegistry } from '@rds-nova/angular-icon';

import { ShellComponent } from './shared/shell/shell.component';
import { LanguageService } from './core/services/language.service';
import { Store } from '@ngrx/store';
import { Feature } from './features/feature-management/enums/feature.enum';
import { selectIsFeatureEnabled } from './features/feature-management/store/selectors/feature-flags.selectors';
import { AppState } from './store';
import { FaqWidgetComponent } from './features/help-faq/components/faq-widget/faq-widget.component';
import { ChatWidgetComponent } from './features/help-faq/components/chat-widget/chat-widget.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ShellComponent, NovaIconRegistry, FaqWidgetComponent, ChatWidgetComponent],
})
export class AppComponent implements OnInit {
  loc: Location = inject(Location);
  isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  get isOutlet(): boolean {
    return ['/ng-app-shell'].includes(this.loc.path()) === false;
  }

  private readonly appStore = inject(Store<AppState>);
  isHelpFaqWidgetEnabled = this.appStore.selectSignal(selectIsFeatureEnabled(Feature.HelpFaqWidget));
  isHelpChatWidgetEnabled = this.appStore.selectSignal(selectIsFeatureEnabled(Feature.HelpAssistWidget));


  title = 'esign';
  languageService = inject(LanguageService);

  translationsLoaded: Signal<boolean> = computed(() =>
    this.languageService.translationsLoaded(),
  );

  async ngOnInit() {
    await this.languageService.initializeApp();
  }
}
